import React from 'react';
import styled from 'styled-components';

export type IconType = keyof typeof mouthMap;
// export const iconTypes: IconType[] = Object.keys(icons) as IconType[];

export const mouthMap = {
  1: 'M49 83.5H51',
  2: 'M50 80.5C49.5 81.5 48.3333 81.8333 47.5 82C47.5 82.5 49 84.5 50 84.5C51 84.5 51.8333 83 52.5 82C51 82 50 80.5 50 80.5Z',
  3: 'M51.5 83C51.5 83.8 51 84.5 50 84.5C49 84.5 48.5 83.8441 48.5 83C48.5 82.1559 49 81.5 50 81.5C50.7552 81.5 51.5 82 51.5 83Z',
  4: 'M48 83C48.1667 83.3333 48.8 84 50 84C51.2 84 51.8333 83.3333 52 83',
  5: 'M48 82.5C47.8267 82.5 47.6658 82.5897 47.5747 82.7371C47.4836 82.8845 47.4753 83.0686 47.5528 83.2236C47.8004 83.7188 48.6023 84.5 50 84.5C51.3977 84.5 52.1996 83.7188 52.4472 83.2236C52.5247 83.0686 52.5164 82.8845 52.4253 82.7371C52.3342 82.5897 52.1733 82.5 52 82.5H48Z',
  6: 'M48.5 84L50 82.5L51.5 84',
  7: 'M50 82L48 83.545C48.6667 83.8884 50.4 84.369 52 83.545L50 82Z',
  8: 'M49 83.5L52 83',
};

export interface Props {
  icon: IconType | string;
  color?: string;
  stroke?: string;
  size?: string | number;
  onClick?: () => void;
}

function Mouth({ icon, color }: Props) {
  return (
    <>
      <path
        d={mouthMap[icon]}
        fill="#E3A9A9"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  );
}

export default Mouth;
